module.exports = __webpack_public_path__ + "static/media/3_Company lobby - Sapporo.807942d4.jpg";